import {NgModule} from '@angular/core'
import {CommonModule, NgOptimizedImage} from '@angular/common'
import {FilesComponent} from './files.component'
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome'
import {PipesModule} from '../../shared/pipes/pipes.module'
import {DirectivesModule} from '../../shared/directives/directives.module'
import {FilesSummaryComponent} from './files-summary/files-summary.component'
import {FileInputComponent} from './file-input/file-input.component'
import {ReactiveFormsModule} from '@angular/forms'
import {SpinnerComponent} from '../spinner/spinner.component'
import {I18nDirective} from '../i18n/i18n.directive'
import {IsPdfPipe} from './pipes/is-pdf.pipe'
import {IsImagePipe} from './pipes/is-image.pipe'
import {FilePreviewComponent} from './file-preview/file-preview.component'
import {FileExtensionPipe} from './pipes/file-extension.pipe'
import {IsBlobPipe} from './pipes/is-blob.pipe'
import {GallerizeDirective} from 'ng-gallery/lightbox'
import {BuildigoImageApiPipe} from '../../core/picture/loaders/buildigo-image-api.pipe'

@NgModule({
  declarations: [
    FilesComponent,
    FilesSummaryComponent,
    FileInputComponent,
    FilePreviewComponent,
    IsPdfPipe,
    IsImagePipe,
    FileExtensionPipe,
  ],
  imports: [
    CommonModule,
    FontAwesomeModule,
    PipesModule,
    DirectivesModule,
    ReactiveFormsModule,
    SpinnerComponent,
    I18nDirective,
    NgOptimizedImage,
    IsBlobPipe,
    GallerizeDirective,
    BuildigoImageApiPipe,
  ],
  exports: [FilesComponent, FilesSummaryComponent, FileInputComponent, IsImagePipe, IsPdfPipe, FilePreviewComponent],
})
export class FilesModule {}
